import { formatMoney, formatQty } from '../lib/format.js'

// Top-3 wasted items today — amber-brand per design rules.
// Renders nothing until at least one log exists; an empty list is just noise on a fresh day.
export default function TopWastedToday({ items }) {
  if (!items || items.length === 0) return null

  return (
    <section className="mx-4 mt-4" aria-label="Top wasted items today">
      <div className="mb-2 flex items-center justify-between">
        <h2 className="text-base font-medium text-amber-brand-600">Top wasted today</h2>
        <span className="text-xs text-black/60">{items.length} of 3</span>
      </div>

      <ol className="overflow-hidden rounded-xl border border-amber-brand-400/30">
        {items.map((it, i) => (
          <li
            key={it.name}
            className={`flex items-center justify-between bg-amber-brand-50 px-4 py-3 ${
              i < items.length - 1 ? 'border-b border-amber-brand-400/20' : ''
            }`}
          >
            <div className="flex items-center gap-3">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-amber-brand-600 text-sm font-medium text-white">
                {i + 1}
              </span>
              <div>
                <div className="text-base font-medium text-black">{it.name}</div>
                <div className="text-xs text-black/60">
                  {formatQty(it.qty, it.unit)} wasted
                </div>
              </div>
            </div>
            <div className="text-base font-medium tabular-nums text-amber-brand-800">
              {formatMoney(it.cost)}
            </div>
          </li>
        ))}
      </ol>
    </section>
  )
}
